import Cookies from 'js-cookie';
export const Modals = (function () {
	'use strict';

	let $a;

	function init() {
		togglePlay();

		$a = $('a[href^="#"]');

		// MicroModal.init({
		// 	onShow: modal => {
		// 		history.replaceState(null, null, `#${modal.id}`);
		// 		document.body.classList.add('modal--is-open');
		// 	},
		// 	onClose: modal => {
		// 		history.replaceState(null, null, ' ');
		// 		document.body.classList.remove('modal--is-open');
		// 	}
		// });

		document.querySelectorAll('[data-micromodal-trigger]').forEach(item => {
			item.addEventListener('click', e => {
				e.preventDefault();
			})
		})

		function togglePlay(){
			var $videoPlay = $('.pop-up-toggle');
			var $thumbnail = $('.pu-video__thumbnail');

			$thumbnail.on('click', function(e){
				$videoPlay.toggleClass('hidden');
				$(this).hide();
			
				
			});
			
		}


		if(!Cookies.get('pop-up-triggered')
			&& $('.pop-up-modal').length){
			setTimeout(function(){

				if($('body.home').length){
					popUpModal();
				}
				else {
					var $modalTrigger = $('.modal-trigger');
					$('.modal-trigger').show();
					$modalTrigger.on('mouseenter', function(e){
						$('.modal-trigger').hide();
						popUpModal();
					})
				}
			}, 8000)
		}


		function popUpModal() {
			
			var $popupmodal = $('.pop-up-modal');

			if ( $popupmodal.is(':visible') ) {

				MicroModal.show('pop-up-modal', {
					onShow: modal => {
						// history.replaceState(null, null, `#${modal.id}`);
						document.body.classList.add('modal--is-open');
					},
					onClose: modal => {
						// history.replaceState(null, null, ' ');
						document.body.classList.remove('modal--is-open');
					},
					disableFocus: true
				});

				Cookies.set('pop-up-triggered', true);

			}

			
		};	

		



		
		


		$a.click(function (e) {
			let href = $(this).attr('href');
			e.preventDefault();
			if (href.length > 1 && $(href + '.modal').length) {
				MicroModal.show(href.replace('#', ''), {
					onShow: modal => {
						history.replaceState(null, null, `#${modal.id}`);
						document.body.classList.add('modal--is-open');
					},
					onClose: modal => {
						history.replaceState(null, null, ' ');
						document.body.classList.remove('modal--is-open');
					},
					disableFocus: true
				});
			}
		})

		if (window.location.hash && window.location.hash.length > 1) {
			var hash = window.location.hash;

			if ($(hash + '.modal').length) {

				document.body.classList.add('modal--is-open');

				MicroModal.show(hash.replace('#', ''), {
					onShow: modal => {
						history.replaceState(null, null, `#${modal.id}`);
						document.body.classList.add('modal--is-open');
					},
					onClose: modal => {
						history.replaceState(null, null, ' ');
						document.body.classList.remove('modal--is-open');
					}
				});
			}
		}

		// stop playing youtube videos by reloading the src
		$('.modal--video [data-micromodal-close]').on('click', function () {
			const $iframe = $(this).closest('.modal').find('iframe')
			$iframe.length && $iframe.attr('src', $iframe.attr('src'))
		})

	}

	return {
		init: init,
	};
})();
